// extracted by mini-css-extract-plugin
module.exports = {"home":"Layout_home__2KwwR","emptyComponent":"Layout_emptyComponent__2m-7w","homeSingle":"Layout_homeSingle__zYpE2"};